(function () {
  'use strict';

  var REPLACEMENTS = [
    { from: /Speichern Sie/g, to: 'Sparen Sie' },
    { from: /Speichern sie/g, to: 'Sparen Sie' }
  ];

  function replaceInText(text) {
    var modified = text;
    for (var i = 0; i < REPLACEMENTS.length; i++) {
      modified = modified.replace(REPLACEMENTS[i].from, REPLACEMENTS[i].to);
    }
    return modified;
  }

  function walkAndReplace(root) {
    if (!root || root.nodeType !== 1) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
    var queue = [];
    var node;
    while ((node = walker.nextNode())) {
      var modified = replaceInText(node.nodeValue);
      if (modified !== node.nodeValue) queue.push({ n: node, v: modified });
    }
    for (var j = 0; j < queue.length; j++) queue[j].n.nodeValue = queue[j].v;
  }

  function handleTextNode(node) {
    var modified = replaceInText(node.nodeValue);
    if (modified !== node.nodeValue) node.nodeValue = modified;
  }

  function init() {
    walkAndReplace(document.body);

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'childList') {
          for (var k = 0; k < m.addedNodes.length; k++) {
            var n = m.addedNodes[k];
            if (n.nodeType === 1) walkAndReplace(n);
            else if (n.nodeType === 3) handleTextNode(n);
          }
        } else if (m.type === 'characterData' && m.target.nodeType === 3) {
          handleTextNode(m.target);
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
